import firebase from 'firebase';
import { useEffect } from 'react';
import { useConfig } from '~/contexts/ConfigContext';
import { useAppDispatch } from '~/redux/hooks';
import { setIsInitializedFirebaseApp } from '~/redux/modules/authentication';
import useFirebaseAuth from './useFirebaseAuth';

const useFirebase = () => {
    const { onSignInAnonymously } = useFirebaseAuth();
    const dispatch = useAppDispatch();
    const { config } = useConfig();

    const init = async () => {
        try {
            if (!config.FIREBASE_clientId) return;

            firebase.initializeApp({
                clientId: config.FIREBASE_clientId,
                appId: config.FIREBASE_appId,
                apiKey: config.FIREBASE_apiKey,
                databaseURL: config.FIREBASE_databaseURL,
                storageBucket: config.FIREBASE_storageBucket,
                messagingSenderId: config.FIREBASE_messagingSenderId,
                projectId: config.FIREBASE_projectId,
                measurementId: config.FIREBASE_measurementId
            });

            await onSignInAnonymously();

            dispatch(setIsInitializedFirebaseApp({
                isInitializedFirebase: true
            }));
        } catch (error) {
            console.log('Error initializing Firebase', error);
        }
    };

    useEffect(() => {
        init();
    }, [config]);
};

export default useFirebase;
